<template>
<div id="app-container" :class="getMenuType">
    <Notice />
    <authority/>
    <top-nav />
    <sidebar />
    <main>
        <div class="container-fluid">
            <router-view />
        </div>
    </main>
    <mobile-footer/>
    <footer-component/>
</div>
</template>

<script>
import Sidebar from '../../containers/Sidebar'
import TopNav from '../../containers/TopNav'
import mobileFooter from '../../containers/mobileFooter'
import Footer from '../../containers/Footer'
import Authority from '../../containers/Authority'
import Notice from '../../containers/NoticeMas'
import {
    mapGetters
} from 'vuex'

export default {
    components: {
        Notice,
        'top-nav': TopNav,
        'sidebar': Sidebar,
        'footer-component': Footer,
        'mobile-footer':mobileFooter,
        'authority' : Authority,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(['getMenuType'])
    }
}
</script>
